import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

const MasterclassFooter = () => (
  <footer className="bg-darker border-t border-white/5 py-10 px-6">
    <div className="max-w-5xl mx-auto flex flex-col md:flex-row items-center justify-between gap-6">
      <motion.p
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true }}
        className="text-cream/30 text-sm font-light"
      >
        ©2019–2026 Jennifer Gräser · Coaching Female · Alle Rechte vorbehalten.
      </motion.p>
      <motion.div
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true }}
        transition={{ delay: 0.2 }}
        className="flex flex-wrap items-center justify-center gap-5 text-xs uppercase tracking-widest text-cream/40"
      >
        {[
          { label: 'Impressum', to: '/impressum' },
          { label: 'Datenschutz', to: '/datenschutz' },
          { label: 'AGB', to: '/agb' },
          { label: 'Love Code', to: '/seelenpartner-love-code' },
          { label: 'Business Code', to: '/female-leadership-fuer-frauen' },
          { label: 'Shop', to: '/shop' },
        ].map(l => (
          <Link key={l.label} to={l.to} className="hover:text-gold transition-colors duration-500">
            {l.label}
          </Link>
        ))}
      </motion.div>
    </div>
  </footer>
);

export default MasterclassFooter;